import pointsEn from './points/en.json';
import pointsZhHant from './points/zh-Hant.json';
import pointsVi from './points/vi.json';
import pointsTh from './points/th.json';

export default {
  en: pointsEn,
  'zh-Hant': pointsZhHant,
  vi: pointsVi,
  th: pointsTh,
};
